import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Widget, WidgetContent, WidgetHeaderWithQuery, } from '@fortem-monorepo/react-spa';
import { CustomAgGrid } from '../CustomAgGrid';
export const AgGridWidget = ({ query, grid, widget, widgetContent, widgetHeader, }) => {
    return (_jsxs(Widget, { ...widget, children: [_jsx(WidgetHeaderWithQuery, { query: query, ...widgetHeader }), _jsx(WidgetContent, { loading: query?.isLoading, ...widgetContent, children: _jsx(CustomAgGrid, { query: query, ...grid }) })] }));
};
